module.exports = __webpack_public_path__ + "static/media/2 5 Ordkjedetest-Riktig.375a119b.mp3";